import React, { useEffect, useRef, useState } from 'react';
import { PauseIcon, PlayIcon } from '../../assets/icons';
import styles from './AudioPlayer.module.css'
const AudioPlayer = ({ url }) => {


    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    // references
    const audioPlayer = useRef();   // reference our audio component
    const progressBar = useRef();   // reference our progress bar
    const animationRef = useRef();  // reference the animation

    var getDuration = function (url, next) {
        var _player = new Audio(url);
        _player.addEventListener("durationchange", function () {
            if (this.duration != Infinity) {
                var duration = this.duration
                _player.removeEventListener("durationchange", this);
                _player.remove();
                next(duration);
            };
        }, false);
        _player.load();
        _player.currentTime = 24 * 60 * 60; //fake big time
        _player.volume = 0;
        // _player.play();
        //waiting...
    };
    useEffect(() => {
        getDuration(url, (val) => {
            if (duration === 0) {
                setDuration(val)
            }

        })
        return () => {
           // setDuration(0)
            audioPlayer.current.removeEventListener("loadeddata", setDuration);
            audioPlayer.current.removeEventListener("timeupdate", setCurrentTime);
        }
    }, [audioPlayer?.current?.loadedmetadata, audioPlayer?.current?.readyState]);

    useEffect(() => {
      
    
      return () => {
        setDuration(0)
      }
    }, [])
    

    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${returnedMinutes}:${returnedSeconds}`;
    }

    const togglePlayPause = () => {
        const prevValue = isPlaying;
        setIsPlaying(!prevValue);
        if (!prevValue) {
            audioPlayer.current.play();
            animationRef.current = requestAnimationFrame(whilePlaying)
        } else {
            audioPlayer.current.pause();
            cancelAnimationFrame(animationRef.current);
        }
    }

    const whilePlaying = () => {
        if (audioPlayer && audioPlayer.current) {
            setCurrentTime(audioPlayer.current.currentTime);
            animationRef.current = requestAnimationFrame(whilePlaying);
        }

    }

    const calcClickedTime = (e) => {
        const clickPositionInPage = e.pageX;
        const bar = progressBar.current;
        const barStart = bar.getBoundingClientRect().left + window.scrollX;
        const barWidth = bar.offsetWidth;
        const clickPositionInBar = clickPositionInPage - barStart;
        const timePerPixel = duration / barWidth;
        return timePerPixel * clickPositionInBar;
    }
    function handleTimeDrag(e) {
        audioPlayer.current.currentTime = calcClickedTime(e);
        const updateTimeOnMove = eMove => {
            audioPlayer.current.currentTime = calcClickedTime(eMove);
        };

        document.addEventListener("mousemove", updateTimeOnMove);

        document.addEventListener("mouseup", () => {
            document.removeEventListener("mousemove", updateTimeOnMove);
        });
        animationRef.current = requestAnimationFrame(whilePlaying)
    }


    return (
        <div className='parent-width'>
            <audio id="audio" ref={audioPlayer} src={url} preload="metadata" />
            <div className="controls">


                <div>
                    <div className="bar">
                        <div
                            ref={progressBar}
                            className={styles.bar_progress}
                            style={{
                                background: `linear-gradient(to right, var(--primary-color-dark) ${((currentTime / duration) !== Infinity ? (currentTime / duration) : 1) * 100}%, var(--secondary-color) 0)`
                            }}
                            onMouseDown={e => handleTimeDrag(e)}
                        >
                        </div>
                        <div className={styles.audio_controls}>
                            <div onClick={togglePlayPause} className={styles.icon_container} >
                                {isPlaying ? <div className={styles.circle_pause}><PauseIcon height={20} /></div> : <div className={styles.circle_pause}><PlayIcon height={40} /></div>}
                            </div>
                            {calculateTime(currentTime)} / {calculateTime(duration)}
                        </div>

                    </div>

                </div>


                {/*   <Bar curTime={curTime} duration={duration} onTimeUpdate={(time) => setClickedTime(time)}/> */}
            </div>
        </div>
    )
};

export default AudioPlayer;
